import EventTarget from '@ungap/event-target'

export const dispatcher = new EventTarget()
